interface TaggrsHeadScriptsProps {
  id: string
  url: string
}

export default function TaggrsHeadScripts({ id, url }: TaggrsHeadScriptsProps) {
  return (
    <>
      <script
        id="taggrs"
        key="taggrs"
        data-cookieconsent="ignore"
        dangerouslySetInnerHTML={{
          __html: `
          (function taggrsLoad(w, d, s, l, i, u) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s);
            j.async = true;
            j.src = u + '/' + i + '.js';
            j.addEventListener('load', function() {
              var _ge = document.createEvent('CustomEvent');
              _ge.initCustomEvent('gtm_loaded', true, false, null);
              d.dispatchEvent(_ge);
            });
            f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', '${id}', '${url}');
        `,
        }}
      />
    </>
  )
}
